import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';

@Component({
  selector: 'app-orderdetail',
  templateUrl: './orderdetail.page.html',
  styleUrls: ['./orderdetail.page.scss'],
})
export class OrderdetailPage implements OnInit {
  @Input() property: string;
  isLoading: boolean = false;
  isProcessing: boolean = false;
  data: any = null;
  constructor(public modalController: ModalController, private callNumber: CallNumber, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) { }

  ionViewWillEnter() {
    if (this.property != '') {
      this.getDetail();
    }
  }

  getDetail() {
    this.isProcessing = true;
    this.restApi.get('user_order_detail/' + this.property).subscribe((data: any) => {
      this.isProcessing = false;
      if (data['code'] == 200) {
        this.data = data['data'];
      }
    }, (error: any) => {
      this.isProcessing = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  ngOnInit() {
  }

  closeDialog() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  makeCall(phno) {
    console.log(phno);
    this.callNumber.callNumber(phno, true)
      .then(res => console.log('Launched dialer!', res))
      .catch(err => console.log('Error launching dialer', err));
  }

  locateOnMap(lat, lng, slat, slng) {
    window.open('https://www.google.com/maps/dir/?api=1&origin=' + lat + ',' + lng + '&destination=' + slat + ',' + slng + '&travelmode=driving', '_blank');
  }
}
